import React from 'react';
import {
  Box, Flex, ShowIf, Text,
} from '../../../shared/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-light-svg-icons';

const ChatMessage = ({ fromName, message }) => {
  const { content, mine, pending } = message;

  const background = mine ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0)';

  return (
    <Flex>
      <ShowIf condition={mine === true}>
        <Box flex={1}></Box>
      </ShowIf>
      <Box mt="8" mb="16" flex={9}>
        <ShowIf condition={mine !== true}>
          <Text color="lightgray" fontSize="12" display="block">{fromName}</Text>
        </ShowIf>
        <ShowIf condition={mine === true}>
          <Text color="lightgray" fontSize="12" display="block" textAlign="right">Tú</Text>
        </ShowIf>
        <Flex bg={background} mt="4" p="12" color="white" border="1px solid white" borderRadius="8px">
          <Box flex={5}>
            <Text lineHeight="1.5">{content}</Text>
          </Box>
          <Box flex={1}>
            <Text fontSize="12" textAlign="right" display="block">
              <ShowIf condition={pending === true}>
                <FontAwesomeIcon icon={faClock} />
              </ShowIf>
            </Text>
          </Box>
        </Flex>
      </Box>
      <ShowIf condition={mine !== true}>
        <Box flex={1}></Box>
      </ShowIf>
    </Flex>
  );
};

export default ChatMessage;
